import { AfterViewInit, Component, Input } from '@angular/core';
import { Location } from '@angular/common';
import { NavigationItem } from '../../navigation';

@Component({
  selector: 'app-nav-group',
  templateUrl: './nav-group.component.html',
  styleUrls: ['./nav-group.component.scss'],
})
export class NavGroupComponent implements AfterViewInit {
  // public props
  @Input() item!: NavigationItem;
  @Input() layout1 = false;

  // constructor
  constructor(private location: Location) {}

  // The anchors are rendered by child views, so this cannot run in ngOnInit.
  ngAfterViewInit(): void {
    this.openActiveSection();
  }

  private openActiveSection(): void {
    const path = this.location.path().split(/[?#]/)[0];
    const externalPath = this.location.prepareExternalUrl(path).split(/[?#]/)[0];
    const link = this.findBestNavLink([path, externalPath]);
    if (!link) {
      return;
    }

    let section: Element | null = link.closest('.pcoded-hasmenu');
    while (section) {
      section.classList.add('pcoded-trigger', 'active');
      section = section.parentElement?.closest('.pcoded-hasmenu') ?? null;
    }
  }

  private findBestNavLink(paths: string[]): HTMLAnchorElement | null {
    const targets = [...new Set(paths.filter(path => path.length > 0))];
    const links = document.querySelectorAll<HTMLAnchorElement>('a.nav-link[href]');
    let best: HTMLAnchorElement | null = null;
    let bestLength = -1;

    links.forEach(link => {
      const href = (link.getAttribute('href') ?? '').split(/[?#]/)[0];
      if (!this.isMenuHref(href)) {
        return;
      }

      const matches = targets.some(target => this.hrefMatches(href, target));
      if (matches && href.length > bestLength) {
        best = link;
        bestLength = href.length;
      }
    });

    return best;
  }

  private isMenuHref(href: string): boolean {
    return href.length > 0 && !href.startsWith('javascript');
  }

  private hrefMatches(href: string, path: string): boolean {
    if (href === path) {
      return true;
    }
    if (href === '/') {
      return false;
    }

    const prefix = href.endsWith('/') ? href : `${href}/`;
    return path.startsWith(prefix);
  }
}
